import { PHASE } from './phases.js';
import { DISASTERS } from '../data/disasters.js';
import { ADVANCED_DISASTER_POOL } from '../data/advancedDisasters.js';
import { DEFAULT_GAME_MODE, GAME_MODE } from '../data/modes.js';
import { configForMode } from './modeConfig.js';

export const DEFAULT_SEED = 1;

function disasterDeckForMode(mode) {
  const pool =
    mode === GAME_MODE.ADVANCED_CAPACITY ? ADVANCED_DISASTER_POOL : DISASTERS;
  return pool.map((d) => d.id);
}

export function createInitialState({
  seed = DEFAULT_SEED,
  mode = DEFAULT_GAME_MODE
} = {}) {
  return {
    phase: PHASE.AWAITING_START,
    mode,
    seed: seed >>> 0,
    year: 1,
    subsidyActive: true,
    subsidyReformedThisYear: false,
    // Advanced Mode starts holding the legacy fossil fleet
    // (section 16.15); Classic starts empty. Copied so a restart
    // cannot mutate the shared constant.
    portfolio: [...configForMode(mode).startingPortfolio],
    pendingBuilds: [],
    pendingRetirements: [],
    buildPlanByYear: {},
    retirePlanByYear: {},
    disasterDeck: disasterDeckForMode(mode),
    drawnDisasterIds: [],
    severityByDisasterId: {},
    persistentDisasterTargets: {},
    riskTierByDisasterId: {},
    rolledOutputs: null,
    yearResults: [],
    cop30: null,
    finalResult: null
  };
}
